var D = Object.defineProperty;
var S = (t, o, n) => o in t ? D(t, o, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[o] = n;
var F = (t, o, n) => S(t, typeof o != "symbol" ? o + "" : o, n);
import { useSyncExternalStore as y, useMemo as E, useEffect as L } from "react";
const w = "en", B = 200, it = B - 80, rt = 20, lt = 1e5, dt = 16, at = 10, nt = 10, st = 2, pt = [
  "#000000",
  "#262626",
  "#595959",
  "#8C8C8C",
  "#BFBFBF",
  "#D9D9D9",
  "#E9E9E9",
  "#F5F5F5",
  "#FAFAFA",
  "#FFFFFF",
  "#F5222D",
  "#FA541C",
  "#FA8C16",
  "#FADB14",
  "#52C41A",
  "#13C2C2",
  "#1890FF",
  "#2F54EB",
  "#722ED1",
  "#EB2F96",
  "#FFE8E6",
  "#FFECE0",
  "#FFEFD1",
  "#FCFCCA",
  "#E4F7D2",
  "#D3F5F0",
  "#D4EEFC",
  "#DEE8FC",
  "#EFE1FA",
  "#FAE1EB",
  "#FFA39E",
  "#FFBB96",
  "#FFD591",
  "#FFFB8F",
  "#B7EB8F",
  "#87E8DE",
  "#91D5FF",
  "#ADC6FF",
  "#D3ADF7",
  "#FFADD2",
  "#FF4D4F",
  "#FF7A45",
  "#FFA940",
  "#FFEC3D",
  "#73D13D",
  "#36CFC9",
  "#40A9FF",
  "#597EF7",
  "#9254DE",
  "#F759AB",
  "#CF1322",
  "#D4380D",
  "#D46B08",
  "#D4B106",
  "#389E0D",
  "#08979C",
  "#096DD9",
  "#1D39C4",
  "#531DAB",
  "#C41D7F",
  "#820014",
  "#871400",
  "#873800",
  "#614700",
  "#135200",
  "#00474F",
  "#003A8C",
  "#061178",
  "#22075E",
  "#780650"
], ut = [
  "Inter",
  "Comic Sans MS, Comic Sans",
  "serif",
  "cursive",
  "Arial",
  "Arial Black",
  "Georgia",
  "Impact",
  "Tahoma",
  "Times New Roman",
  "Verdana",
  "Courier New",
  "Lucida Console",
  "Monaco",
  "monospace"
], gt = [
  "10px",
  "11px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "36px",
  "48px",
  "72px"
], mt = "default";
var R = /* @__PURE__ */ ((t) => (t[t["size-small"] = 200] = "size-small", t[t["size-medium"] = 500] = "size-medium", t["size-large"] = "100%", t))(R || {}), I = /* @__PURE__ */ ((t) => (t[t["size-small"] = 480] = "size-small", t[t["size-medium"] = 640] = "size-medium", t["size-large"] = "100%", t))(I || {});
const ct = ["100%", "115%", "150%", "200%", "250%", "300%"], ht = "1", ft = [
  "bold",
  "italic",
  "underline",
  "strike",
  "code",
  "link",
  "divider",
  "color",
  "highlight",
  "textAlign"
];
function W({
  updateComputed: t,
  notifyEffect: o
}) {
  let n, s;
  return {
    /**
     * Links a given dependency and subscriber if they are not already linked.
     * 
     * @param dep - The dependency to be linked.
     * @param sub - The subscriber that depends on this dependency.
     * @returns The newly created link object if the two are not already linked; otherwise `undefined`.
     */
    link(e, i) {
      const r = i.depsTail;
      if (r !== void 0 && r.dep === e)
        return;
      const d = r !== void 0 ? r.nextDep : i.deps;
      if (d !== void 0 && d.dep === e) {
        i.depsTail = d;
        return;
      }
      const l = e.subsTail;
      if (!(l !== void 0 && l.sub === i && h(l, i)))
        return p(e, i, d, r);
    },
    /**
     * Traverses and marks subscribers starting from the provided link.
     * 
     * It sets flags (e.g., Dirty, PendingComputed, PendingEffect) on each subscriber
     * to indicate which ones require re-computation or effect processing. 
     * This function should be called after a signal's value changes.
     * 
     * @param link - The starting link from which propagation begins.
     */
    propagate(e) {
      let i = 32, r = e, d = 0;
      t: do {
        const l = e.sub, a = l.flags;
        if (!(a & 244) && (l.flags = a | i | 8, !0) || a & 16 && !(a & 4) && (l.flags = a & -17 | i | 8, !0) || !(a & 224) && h(e, l) && (l.flags = a | 16 | i | 8, l.subs !== void 0)) {
          const g = l.subs;
          if (g !== void 0) {
            g.nextSub !== void 0 ? (g.prevSub = r, e = r = g, i = 64, ++d) : (e = g, i = a & 2 ? 128 : 64);
            continue;
          }
          a & 2 && (s !== void 0 ? s.depsTail.nextDep = l.deps : n = l, s = l);
        } else a & (4 | i) ? !(a & i) && a & 224 && h(e, l) && (l.flags = a | i) : (l.flags = a | i | 8, (a & 10) === 2 && (s !== void 0 ? s.depsTail.nextDep = l.deps : n = l, s = l));
        if ((e = r.nextSub) !== void 0) {
          r = e, i = d ? 64 : 32;
          continue;
        }
        for (; d; ) {
          --d;
          const x = r.dep.subs;
          if (r = x.prevSub, x.prevSub = void 0, (e = r.nextSub) !== void 0) {
            r = e, i = d ? 64 : 32;
            continue t;
          }
        }
        break;
      } while (!0);
    },
    /**
     * Prepares the given subscriber to track new dependencies.
     * 
     * It resets the subscriber's internal pointers (e.g., depsTail) and
     * sets its flags to indicate it is now tracking dependency links.
     * 
     * @param sub - The subscriber to start tracking.
     */
    startTracking(e) {
      e.depsTail = void 0, e.flags = e.flags & -249 | 4;
    },
    /**
     * Concludes tracking of dependencies for the specified subscriber.
     * 
     * It clears or unlinks any tracked dependency information, then
     * updates the subscriber's flags to indicate tracking is complete.
     * 
     * @param sub - The subscriber whose tracking is ending.
     */
    endTracking(e) {
      const i = e.depsTail;
      if (i !== void 0) {
        const r = i.nextDep;
        r !== void 0 && (T(r), i.nextDep = void 0);
      } else e.deps !== void 0 && (T(e.deps), e.deps = void 0);
      e.flags &= -5;
    },
    /**
     * Updates the dirty flag for the given subscriber based on its dependencies.
     * 
     * If the subscriber has any pending computeds, this function sets the Dirty flag
     * and returns `true`. Otherwise, it clears the PendingComputed flag and returns `false`.
     * 
     * @param sub - The subscriber to update.
     * @param flags - The current flag set for this subscriber.
     * @returns `true` if the subscriber is marked as Dirty; otherwise `false`.
     */
    updateDirtyFlag(e, i) {
      return v(e.deps) ? (e.flags = i | 32, !0) : (e.flags = i & -65, !1);
    },
    /**
     * Updates the computed subscriber if necessary before its value is accessed.
     * 
     * If the subscriber is marked Dirty or PendingComputed, this function runs
     * the provided updateComputed logic and triggers a shallowPropagate for any
     * downstream subscribers if an actual update occurs.
     * 
     * @param computed - The computed subscriber to update.
     * @param flags - The current flag set for this subscriber.
     */
    processComputedUpdate(e, i) {
      if ((i & 32 || (v(e.deps) || (e.flags = i & -65, !1))) && t(e)) {
        const r = e.subs;
        r !== void 0 && c(r);
      }
    },
    /**
     * Ensures all pending internal effects for the given subscriber are processed.
     * 
     * This should be called after an effect decides not to re-run itself but may still
     * have dependencies flagged with PendingEffect. If the subscriber is flagged with
     * PendingEffect, this function clears that flag and invokes `notifyEffect` on any
     * related dependencies marked as Effect and Propagated, processing pending effects.
     * 
     * @param sub - The subscriber which may have pending effects.
     * @param flags - The current flags on the subscriber to check.
     */
    processPendingInnerEffects(e, i) {
      if (i & 128) {
        e.flags = i & -129;
        let r = e.deps;
        do {
          const d = r.dep;
          "flags" in d && d.flags & 2 && d.flags & 224 && o(d), r = r.nextDep;
        } while (r !== void 0);
      }
    },
    /**
     * Processes queued effect notifications after a batch operation finishes.
     * 
     * Iterates through all queued effects, calling notifyEffect on each.
     * If an effect remains partially handled, its flags are updated, and future
     * notifications may be triggered until fully handled.
     */
    processEffectNotifications() {
      for (; n !== void 0; ) {
        const e = n, i = e.depsTail, r = i.nextDep;
        r !== void 0 ? (i.nextDep = void 0, n = r.sub) : (n = void 0, s = void 0), o(e) || (e.flags &= -9);
      }
    }
  };
  function p(e, i, r, d) {
    const l = {
      dep: e,
      sub: i,
      nextDep: r,
      prevSub: void 0,
      nextSub: void 0
    };
    if (d === void 0 ? i.deps = l : d.nextDep = l, e.subs === void 0)
      e.subs = l;
    else {
      const a = e.subsTail;
      l.prevSub = a, a.nextSub = l;
    }
    return i.depsTail = l, e.subsTail = l, l;
  }
  function v(e) {
    let i = 0, r;
    t: do {
      r = !1;
      const d = e.dep;
      if ("flags" in d) {
        const l = d.flags;
        if ((l & 33) === 33) {
          if (t(d)) {
            const a = d.subs;
            a.nextSub !== void 0 && c(a), r = !0;
          }
        } else if ((l & 65) === 65) {
          const a = d.subs;
          a.nextSub !== void 0 && (a.prevSub = e), e = d.deps, ++i;
          continue;
        }
      }
      if (!r && e.nextDep !== void 0) {
        e = e.nextDep;
        continue;
      }
      if (i) {
        let l = e.sub;
        do {
          --i;
          const a = l.subs;
          if (r) {
            if (t(l)) {
              (e = a.prevSub) !== void 0 ? (a.prevSub = void 0, c(l.subs), l = e.sub) : l = a.sub;
              continue;
            }
          } else
            l.flags &= -65;
          if ((e = a.prevSub) !== void 0) {
            if (a.prevSub = void 0, e.nextDep !== void 0) {
              e = e.nextDep;
              continue t;
            }
            l = e.sub;
          } else {
            if ((e = a.nextDep) !== void 0)
              continue t;
            l = a.sub;
          }
          r = !1;
        } while (i);
      }
      return r;
    } while (!0);
  }
  function c(e) {
    do {
      const i = e.sub, r = i.flags;
      (r & 96) === 64 && (i.flags = r | 32 | 8, (r & 10) === 2 && (s !== void 0 ? s.depsTail.nextDep = i.deps : n = i, s = i)), e = e.nextSub;
    } while (e !== void 0);
  }
  function h(e, i) {
    const r = i.depsTail;
    if (r !== void 0) {
      let d = i.deps;
      do {
        if (d === e)
          return !0;
        if (d === r)
          break;
        d = d.nextDep;
      } while (d !== void 0);
    }
    return !1;
  }
  function T(e) {
    do {
      const i = e.dep, r = e.nextDep, d = e.nextSub, l = e.prevSub;
      if (d !== void 0 ? d.prevSub = l : i.subsTail = l, l !== void 0 ? l.nextSub = d : i.subs = d, i.subs === void 0 && "deps" in i) {
        const a = i.flags;
        a & 32 || (i.flags = a | 32);
        const g = i.deps;
        if (g !== void 0) {
          e = g, i.depsTail.nextDep = r, i.deps = void 0, i.depsTail = void 0;
          continue;
        }
      }
      e = r;
    } while (e !== void 0);
  }
}
var {
  link: C,
  propagate: N,
  updateDirtyFlag: P,
  startTracking: b,
  endTracking: k,
  processEffectNotifications: U,
  processComputedUpdate: bt,
  processPendingInnerEffects: _
} = W({
  updateComputed(t) {
    const o = u;
    u = t, b(t);
    try {
      const n = t.currentValue, s = t.getter(n);
      return n !== s ? (t.currentValue = s, !0) : !1;
    } finally {
      u = o, k(t);
    }
  },
  notifyEffect(t) {
    return "isScope" in t ? H(t) : q(t);
  }
}), u;
function j(t) {
  return K.bind({
    currentValue: t,
    subs: void 0,
    subsTail: void 0
  });
}
function M(t) {
  const o = {
    fn: t,
    subs: void 0,
    subsTail: void 0,
    deps: void 0,
    depsTail: void 0,
    flags: 2
    /* Effect */
  };
  return u !== void 0 && C(o, u), z(o), O.bind(o);
}
function z(t) {
  const o = u;
  u = t, b(t);
  try {
    t.fn();
  } finally {
    u = o, k(t);
  }
}
function q(t) {
  const o = t.flags;
  return o & 32 || o & 64 && P(t, o) ? z(t) : _(t, t.flags), !0;
}
function H(t) {
  return t.flags & 128 ? (_(t, t.flags), !0) : !1;
}
function K(...t) {
  if (t.length) {
    if (this.currentValue !== (this.currentValue = t[0])) {
      const o = this.subs;
      o !== void 0 && (N(o), U());
    }
  } else
    return u !== void 0 && C(this, u), this.currentValue;
}
function O() {
  b(this), k(this);
}
function G(t) {
  return j(t);
}
function V(t) {
  return [y((o) => {
    let n = M(() => {
      t(), o();
    });
    return () => n();
  }, () => t(), () => t()), (o) => {
    t(typeof o == "function" ? o(t()) : o);
  }];
}
const X = {
  "editor.remove": "Remove",
  "editor.copy": "Copy",
  "editor.words": "WORDS",
  "editor.characters": "CHARACTERS",
  "editor.default": "Default",
  "editor.recent": "Recently Used",
  "editor.nofill": "No Fill",
  "editor.format": "Format Painter",
  "editor.delete": "Delete",
  "editor.edit": "Edit",
  "editor.settings": "Settings",
  "editor.table_of_content": "Table of Content",
  "editor.draghandle.tooltip": "Modify",
  "editor.copyToClipboard": "CopyToClipboard",
  "editor.slash": "Press '/' for commands",
  "editor.slash.empty": "No Result",
  "editor.slash.format": "Format",
  "editor.slash.insert": "Insert",
  "editor.slash.embed": "Embed Services",
  "editor.content": "Please input content",
  "editor.fontFamily.tooltip": "Font Family",
  "editor.fontFamily.default.tooltip": "Default",
  "editor.moremark": "More Text Styles",
  "editor.size.small.tooltip": "Small",
  "editor.size.medium.tooltip": "Medium",
  "editor.size.large.tooltip": "Cover",
  "editor.bold.tooltip": "Bold",
  "editor.italic.tooltip": "Italic",
  "editor.underline.tooltip": "Underline",
  "editor.strike.tooltip": "Strike",
  "editor.color.tooltip": "Color",
  "editor.color.more": "More Colors",
  "editor.highlight.tooltip": "Highlight",
  "editor.lineheight.tooltip": "Line Height",
  "editor.heading.tooltip": "Headings",
  "editor.heading.h1.tooltip": "Heading 1",
  "editor.heading.h2.tooltip": "Heading 2",
  "editor.heading.h3.tooltip": "Heading 3",
  "editor.heading.h4.tooltip": "Heading 4",
  "editor.heading.h5.tooltip": "Heading 5",
  "editor.heading.h6.tooltip": "Heading 6",
  "editor.paragraph.tooltip": "Paragraph",
  "editor.textalign.tooltip": "Align",
  "editor.textalign.left.tooltip": "Left",
  "editor.textalign.center.tooltip": "Center",
  "editor.textalign.right.tooltip": "Right",
  "editor.textalign.justify.tooltip": "Justify",
  "editor.indent": "Indent",
  "editor.indent.indent": "Increase Indent",
  "editor.indent.outdent": "Decrease Indent",
  "editor.fontSize.tooltip": "Font size",
  "editor.fontSize.default.tooltip": "Default",
  "editor.superscript.tooltip": "Superscript",
  "editor.subscript.tooltip": "Subscript",
  "editor.bulletlist.tooltip": "Bullet List",
  "editor.orderedlist.tooltip": "Ordered List",
  "editor.tasklist.tooltip": "Task List",
  "editor.indent.tooltip": "Indent",
  "editor.outdent.tooltip": "Outdent",
  "editor.columns.tooltip": "Columns",
  "editor.link.tooltip": "Link",
  "editor.link.unlink.tooltip": "UnLink",
  "editor.link.open.tooltip": "Open Link",
  "editor.link.edit.tooltip": "Edit Link",
  "editor.link.dialog.title": "Insert Link",
  "editor.link.dialog.link": "Link",
  "editor.link.dialog.text": "Text",
  "editor.link.dialog.openInNewTab": "Open In New Tab",
  "editor.link.dialog.link.placeholder": "Link Address",
  "editor.link.dialog.text.placeholder": "Add Description",
  "editor.link.dialog.button.apply": "Apply",
  "editor.image.tooltip": "Image",
  "editor.image.dragger.tooltip": "Click or drag the image to the area to upload",
  "editor.image.float.left.tooltip": "Float left",
  "editor.image.float.none.tooltip": "Float none",
  "editor.image.float.right.tooltip": "Float right",
  "editor.image.dialog.title": "Add an image",
  "editor.image.dialog.tab.url": "Url",
  "editor.image.dialog.tab.upload": "Upload",
  "editor.image.dialog.tab.uploadCrop": "Upload & Crop",
  "editor.image.dialog.uploading": "Uploading",
  "editor.link.dialog.inline": "Inline",
  "editor.image.dialog.form.link": "Link",
  "editor.image.dialog.placeholder": "Link",
  "editor.image.dialog.form.alt": "Alt",
  "editor.image.dialog.form.aspectRatio": "Lock original aspect ratio",
  "editor.image.dialog.form.file": "File",
  "editor.image.dialog.button.apply": "Apply",
  "editor.video.tooltip": "Video",
  "editor.video.dialog.tab.upload": "Upload",
  "editor.video.dialog.uploading": "Uploading",
  "editor.video.dialog.title": "Embed or upload a video",
  "editor.video.dialog.link": "Link",
  "editor.video.dialog.placeholder": "Link",
  "editor.video.dialog.button.apply": "Apply",
  "editor.table.tooltip": "Table",
  "editor.table.menu.insert_table": "Insert Table",
  "editor.table.menu.insert_table.with_header_row": "With header row",
  "editor.table.menu.add_column_before": "Add Column Before",
  "editor.table.menu.add_column_after": "Add Column After",
  "editor.table.menu.delete_column": "Delete Column",
  "editor.table.menu.add_row_before": "Add Row Before",
  "editor.table.menu.add_row_after": "Add Row After",
  "editor.table.menu.delete_row": "Delete Row",
  "editor.table.menu.merge_or_split_cells": "Merge Or Split Cells",
  "editor.table.menu.delete_table": "Delete Table",
  "editor.blockquote.tooltip": "Blockquote",
  "editor.horizontalrule.tooltip": "Horizontal Rule",
  "editor.code.tooltip": "Code",
  "editor.codeblock.tooltip": "Code Block",
  "editor.clear.tooltip": "Clear Format",
  "editor.undo.tooltip": "Undo",
  "editor.redo.tooltip": "Redo",
  "editor.fullscreen.tooltip.fullscreen": "Fullscreen",
  "editor.fullscreen.tooltip.exit": "Fullscreen Exit",
  "editor.imageUpload.cancel": "Cancel",
  "editor.imageUpload.crop": "Crop",
  "editor.imageUpload.fileTypeNotSupported": "File type not supported",
  "editor.imageUpload.fileSizeTooBig": "File size too big, Maximum size is",
  "editor.table.menu.insertColumnBefore": "Insert Column Before",
  "editor.table.menu.insertColumnAfter": "Insert Column After",
  "editor.table.menu.deleteColumn": "Delete Column",
  "editor.table.menu.insertRowAbove": "Insert Row Above",
  "editor.table.menu.insertRowBelow": "Insert Row Below",
  "editor.table.menu.deleteRow": "Delete Row",
  "editor.table.menu.mergeCells": "Merge Cells",
  "editor.table.menu.splitCells": "Split Cells",
  "editor.table.menu.deleteTable": "Delete Table",
  "editor.table.menu.setCellsBgColor": "Cell Background Color",
  "editor.emoji.tooltip": "Emoji",
  "editor.iframe.tooltip": "Iframe",
  "editor.searchAndReplace.tooltip": "Search and Replace",
  "editor.search.dialog.text": "Search",
  "editor.replace.dialog.text": "Replace",
  "editor.replaceAll.dialog.text": "Replace All",
  "editor.previous.dialog.text": "Previous",
  "editor.next.dialog.text": "Next",
  no_result_found: "No results found",
  "Smileys & People": "Smileys & People",
  "Animals & Nature": "Animals & Nature",
  "Food & Drink": "Food & Drink",
  Activity: "Activity",
  "Travel & Places": "Travel & Places",
  Object: "Objects",
  Symbol: "Symbols",
  Flags: "Flags",
  "Frequently used": "Frequently used",
  "editor.formula.dialog.text": "Formula",
  "editor.katex.tooltip": "Math Formula",
  "editor.exportPdf.tooltip": "Export PDF",
  "editor.exportWord.tooltip": "Export Word",
  "editor.importWord.tooltip": "Import Word",
  "editor.importWord.limitSize": "File size cannot exceed",
  "editor.importWord.converting": "Converting Word document, please wait...",
  "editor.importWord.convertError": "Error parsing Word document",
  "editor.importWord.importError": "Error importing Word document",
  "editor.textDirection.tooltip": "Text Direction",
  "editor.textDirection.auto.tooltip": "Auto",
  "editor.textDirection.ltr.tooltip": "Left to Right",
  "editor.textDirection.rtl.tooltip": "Right to Left",
  "editor.attachment.tooltip": "Attachment",
  "editor.attachment.uploading": "Uploading",
  "editor.attachment.please_upload": "Please upload the file",
  "editor.imageGif.tooltip": "Gif",
  "editor.replace.caseSensitive": "Case Sensitive",
  "editor.mermaid.tooltip": "Mermaid",
  "editor.twitter.tooltip": "Twitter",
  "editor.tooltip.flipX": "Flip Horizontal",
  "editor.tooltip.flipY": "Flip Vertical"
}, $ = {
  "editor.remove": "Remover",
  "editor.copy": "Copiar",
  "editor.words": "PALAVRAS",
  "editor.characters": "CARACTERES",
  "editor.default": "Padrão",
  "editor.recent": "Usado recentemente",
  "editor.nofill": "Sem preenchimento",
  "editor.format": "Format Painter",
  "editor.delete": "Deletar",
  "editor.edit": "Editar",
  "editor.settings": "Configurações",
  "editor.table_of_content": "Tabela de conteúdos",
  "editor.draghandle.tooltip": "Modificar",
  "editor.copyToClipboard": "Copiar para a área de transferência",
  "editor.slash": "Pressione '/' para comandos",
  "editor.slash.empty": "Nenhum resultado",
  "editor.slash.format": "Formato",
  "editor.slash.insert": "Inserir",
  "editor.slash.embed": "Incorporar serviços",
  "editor.content": "Por favor, insira o conteúdo",
  "editor.fontFamily.tooltip": "Fonte",
  "editor.fontFamily.default.tooltip": "Padrão",
  "editor.moremark": "Mais estilos de texto",
  "editor.size.small.tooltip": "Pequeno",
  "editor.size.medium.tooltip": "Médio",
  "editor.size.large.tooltip": "Grande",
  "editor.bold.tooltip": "Negrito",
  "editor.italic.tooltip": "Itálico",
  "editor.underline.tooltip": "Sublinhado",
  "editor.strike.tooltip": "Riscado",
  "editor.color.tooltip": "Cor",
  "editor.color.more": "Mais cores",
  "editor.highlight.tooltip": "Destaque",
  "editor.lineheight.tooltip": "Altura da linha",
  "editor.heading.tooltip": "Cabeçalhos",
  "editor.heading.h1.tooltip": "Cabeçalho 1",
  "editor.heading.h2.tooltip": "Cabeçalho 2",
  "editor.heading.h3.tooltip": "Cabeçalho 3",
  "editor.heading.h4.tooltip": "Cabeçalho 4",
  "editor.heading.h5.tooltip": "Cabeçalho 5",
  "editor.heading.h6.tooltip": "Cabeçalho 6",
  "editor.paragraph.tooltip": "Parágrafo",
  "editor.textalign.tooltip": "Alinhar",
  "editor.textalign.left.tooltip": "Esquerda",
  "editor.textalign.center.tooltip": "Centro",
  "editor.textalign.right.tooltip": "Direita",
  "editor.textalign.justify.tooltip": "Justificar",
  "editor.indent": "Recuo",
  "editor.indent.indent": "Aumentar recuo",
  "editor.indent.outdent": "Diminuir recuo",
  "editor.fontSize.tooltip": "Tamanho da fonte",
  "editor.fontSize.default.tooltip": "Padrão",
  "editor.superscript.tooltip": "Sobrescrito",
  "editor.subscript.tooltip": "Subscrito",
  "editor.bulletlist.tooltip": "Lista de marcadores",
  "editor.orderedlist.tooltip": "Lista numerada",
  "editor.tasklist.tooltip": "Lista de tarefas",
  "editor.indent.tooltip": "Recuo",
  "editor.outdent.tooltip": "Diminuir recuo",
  "editor.columns.tooltip": "Colunas",
  "editor.link.tooltip": "Link",
  "editor.link.unlink.tooltip": "Desvincular",
  "editor.link.open.tooltip": "Abrir link",
  "editor.link.edit.tooltip": "Editar link",
  "editor.link.dialog.title": "Inserir link",
  "editor.link.dialog.link": "Link",
  "editor.link.dialog.text": "Texto",
  "editor.link.dialog.openInNewTab": "Abrir em nova guia",
  "editor.link.dialog.link.placeholder": "Endereço do link",
  "editor.link.dialog.text.placeholder": "Texto do link",
  "editor.link.dialog.button.apply": "Aplicar",
  "editor.image.tooltip": "Imagem",
  "editor.image.dragger.tooltip": "Clique ou arraste a imagem para a área de upload",
  "editor.image.float.left.tooltip": "Flutuar à esquerda",
  "editor.image.float.none.tooltip": "Nenhum flutuante",
  "editor.image.float.right.tooltip": "Flutuar à direita",
  "editor.image.dialog.title": "Adicionar uma imagem",
  "editor.image.dialog.tab.url": "Url",
  "editor.image.dialog.tab.upload": "Enviar",
  "editor.link.dialog.inline": "Inline",
  "editor.image.dialog.tab.uploadCrop": "Enviar e cortar",
  "editor.image.dialog.uploading": "Enviando",
  "editor.image.dialog.form.link": "Link",
  "editor.image.dialog.placeholder": "Link",
  "editor.image.dialog.form.alt": "Alt",
  "editor.image.dialog.form.aspectRatio": "Bloquear proporção original",
  "editor.image.dialog.form.file": "Arquivo",
  "editor.image.dialog.button.apply": "Aplicar",
  "editor.video.tooltip": "Vídeo",
  "editor.video.dialog.tab.upload": "Enviar",
  "editor.video.dialog.uploading": "Enviando",
  "editor.video.dialog.title": "Incorporar ou enviar um vídeo",
  "editor.video.dialog.link": "Link",
  "editor.video.dialog.placeholder": "Link",
  "editor.video.dialog.button.apply": "Aplicar",
  "editor.table.tooltip": "Tabela",
  "editor.table.menu.insert_table": "Inserir tabela",
  "editor.table.menu.insert_table.with_header_row": "Com linha de cabeçalho",
  "editor.table.menu.add_column_before": "Adicionar coluna antes",
  "editor.table.menu.add_column_after": "Adicionar coluna depois",
  "editor.table.menu.delete_column": "Excluir coluna",
  "editor.table.menu.add_row_before": "Adicionar linha antes",
  "editor.table.menu.add_row_after": "Adicionar linha depois",
  "editor.table.menu.delete_row": "Deletar linha",
  "editor.table.menu.merge_or_split_cells": "Mesclar ou dividir células",
  "editor.table.menu.delete_table": "Deletar tabela",
  "editor.blockquote.tooltip": "Citação",
  "editor.horizontalrule.tooltip": "Regra horizontal",
  "editor.code.tooltip": "Código",
  "editor.codeblock.tooltip": "Bloco de código",
  "editor.clear.tooltip": "Limpar formato",
  "editor.undo.tooltip": "Desfazer",
  "editor.redo.tooltip": "Refazer",
  "editor.fullscreen.tooltip.fullscreen": "Tela cheia",
  "editor.fullscreen.tooltip.exit": "Sair da tela cheia",
  "editor.imageUpload.cancel": "Cancelar",
  "editor.imageUpload.crop": "Cortar",
  "editor.imageUpload.fileTypeNotSupported": "Tipo de arquivo não suportado",
  "editor.imageUpload.fileSizeTooBig": "Tamanho do arquivo muito grande, tamanho máximo é",
  "editor.table.menu.insertColumnBefore": "Inserir coluna antes",
  "editor.table.menu.insertColumnAfter": "Inserir coluna depois",
  "editor.table.menu.deleteColumn": "Excluir coluna",
  "editor.table.menu.insertRowAbove": "Inserir linha acima",
  "editor.table.menu.insertRowBelow": "Inserir linha abaixo",
  "editor.table.menu.deleteRow": "Deletar linha",
  "editor.table.menu.mergeCells": "Mesclar células",
  "editor.table.menu.splitCells": "Dividir células",
  "editor.table.menu.deleteTable": "Deletar tabela",
  "editor.table.menu.setCellsBgColor": "Cor de fundo da célula",
  "editor.emoji.tooltip": "Emoji",
  "editor.iframe.tooltip": "Iframe",
  "editor.searchAndReplace.tooltip": "Pesquisar e substituir",
  "editor.search.dialog.text": "Pesquisar",
  "editor.replace.dialog.text": "Substituir",
  "editor.replaceAll.dialog.text": "Substituir tudo",
  "editor.previous.dialog.text": "Anterior",
  "editor.next.dialog.text": "Próximo",
  no_result_found: "Nenhum resultado encontrado",
  "Smileys & People": "Emoticons & Pessoas",
  "Animals & Nature": "Animais & Natureza",
  "Food & Drink": "Comida & Bebida",
  Activity: "Atividade",
  "Travel & Places": "Viagem & Lugares",
  Object: "Objetos",
  Symbol: "Símbolos",
  Flags: "Bandeiras",
  "Frequently used": "Frequentemente usado",
  "editor.formula.dialog.text": "Fórmula",
  "editor.katex.tooltip": "Fórmula matemática",
  "editor.exportPdf.tooltip": "Exportar PDF",
  "editor.exportWord.tooltip": "Exportar Word",
  "editor.importWord.tooltip": "Importar Word",
  "editor.importWord.limitSize": "O tamanho do arquivo não pode exceder",
  "editor.importWord.converting": "Convertendo documento do Word, aguarde...",
  "editor.importWord.convertError": "Erro ao analisar documento do Word",
  "editor.importWord.importError": "Erro ao importar documento do Word",
  "editor.textDirection.tooltip": "Direção do texto",
  "editor.textDirection.auto.tooltip": "Automático",
  "editor.textDirection.ltr.tooltip": "Esquerda para Direita",
  "editor.textDirection.rtl.tooltip": "Direita para Esquerda",
  "editor.attachment.tooltip": "Anexo",
  "editor.attachment.uploading": "Enviando",
  "editor.attachment.please_upload": "Por favor, envie o arquivo",
  "editor.imageGif.tooltip": "Gif",
  "editor.replace.caseSensitive": "Sensível a maiúsculas e minúsculas",
  "editor.mermaid.tooltip": "Mermaid",
  "editor.twitter.tooltip": "Twitter",
  "editor.tooltip.flipX": "Inverter Horizontal",
  "editor.tooltip.flipY": "Inverter Vertical"
}, Y = {
  "editor.remove": "Xóa",
  "editor.copy": "Sao chép",
  "editor.words": "TỪ",
  "editor.characters": "KÝ TỰ",
  "editor.default": "Mặc định",
  "editor.recent": "Đã sử dụng gần đây",
  "editor.nofill": "Không tô",
  "editor.format": "Format Painter",
  "editor.delete": "Xóa",
  "editor.edit": "Chỉnh sửa",
  "editor.settings": "Cài đặt",
  "editor.table_of_content": "Mục lục",
  "editor.draghandle.tooltip": "Sửa đổi",
  "editor.copyToClipboard": "CopyToClipboard",
  "editor.slash": "Nhấn '/' để biết lệnh",
  "editor.slash.empty": "Không có kết quả",
  "editor.slash.format": "Định dạng",
  "editor.slash.insert": "Chèn",
  "editor.slash.embed": "Dịch vụ nhúng",
  "editor.content": "Vui lòng nhập nội dung",
  "editor.moremark": "Nhiều kiểu văn bản hơn",
  "editor.size.small.tooltip": "Nhỏ",
  "editor.fontFamily.tooltip": "Phông chữ",
  "editor.fontFamily.default.tooltip": "Mặc định",
  "editor.size.medium.tooltip": "Trung bình",
  "editor.size.large.tooltip": "Lớn",
  "editor.bold.tooltip": "Đậm",
  "editor.italic.tooltip": "In nghiêng",
  "editor.underline.tooltip": "Gạch chân",
  "editor.strike.tooltip": "Gạch",
  "editor.color.tooltip": "Màu",
  "editor.color.more": "Nhiều màu hơn",
  "editor.highlight.tooltip": "Đánh dấu",
  "editor.lineheight.tooltip": "Chiều cao dòng",
  "editor.heading.tooltip": "Tiêu đề",
  "editor.heading.h1.tooltip": "Tiêu đề 1",
  "editor.heading.h2.tooltip": "Tiêu đề 2",
  "editor.heading.h3.tooltip": "Tiêu đề 3",
  "editor.heading.h4.tooltip": "Tiêu đề 4",
  "editor.heading.h5.tooltip": "Tiêu đề 5",
  "editor.heading.h6.tooltip": "Tiêu đề 6",
  "editor.paragraph.tooltip": "Đoạn văn",
  "editor.textalign.tooltip": "Căn chỉnh",
  "editor.textalign.left.tooltip": "Trái",
  "editor.textalign.center.tooltip": "Giữa",
  "editor.textalign.right.tooltip": "Phải",
  "editor.textalign.justify.tooltip": "Căn đều",
  "editor.indent": "Thụt lề",
  "editor.indent.indent": "Tăng thụt lề",
  "editor.indent.outdent": "Giảm thụt lề",
  "editor.fontSize.tooltip": "Kích thước phông chữ",
  "editor.fontSize.default.tooltip": "Mặc định",
  "editor.superscript.tooltip": "Chỉ số trên",
  "editor.subscript.tooltip": "Chỉ số dưới",
  "editor.bulletlist.tooltip": "Danh sách dấu đầu dòng",
  "editor.orderedlist.tooltip": "Danh sách có thứ tự",
  "editor.tasklist.tooltip": "Danh sách tác vụ",
  "editor.indent.tooltip": "Tăng thụt lề",
  "editor.outdent.tooltip": "Giảm thụt lề",
  "editor.columns.tooltip": "Cột",
  "editor.link.tooltip": "Liên kết",
  "editor.link.unlink.tooltip": "Hủy liên kết",
  "editor.link.open.tooltip": "Mở liên kết",
  "editor.link.edit.tooltip": "Chỉnh sửa liên kết",
  "editor.link.dialog.title": "Chèn liên kết",
  "editor.link.dialog.link": "Liên kết",
  "editor.link.dialog.text": "Văn bản",
  "editor.link.dialog.openInNewTab": "Mở trong tab mới",
  "editor.link.dialog.link.placeholder": "Địa chỉ liên kết",
  "editor.link.dialog.text.placeholder": "Thêm mô tả",
  "editor.link.dialog.button.apply": "Áp dụng",
  "editor.image.tooltip": "Hình ảnh",
  "editor.image.dragger.tooltip": "Nhấp hoặc kéo hình ảnh đến khu vực để tải lên",
  "editor.image.float.left.tooltip": "Trôi sang trái",
  "editor.image.float.none.tooltip": "Trôi không",
  "editor.image.float.right.tooltip": "Trôi sang phải",
  "editor.image.dialog.title": "Thêm hình ảnh",
  "editor.image.dialog.tab.url": "Url",
  "editor.image.dialog.tab.upload": "Tải lên",
  "editor.link.dialog.inline": "Inline",
  "editor.image.dialog.tab.uploadCrop": "Tải lên & Cắt",
  "editor.image.dialog.uploading": "Đang tải lên",
  "editor.image.dialog.form.link": "Liên kết",
  "editor.image.dialog.placeholder": "Liên kết",
  "editor.image.dialog.form.alt": "Alt",
  "editor.image.dialog.form.aspectRatio": "Khóa tỷ lệ khung hình gốc",
  "editor.image.dialog.form.file": "Tệp",
  "editor.image.dialog.button.apply": "Áp dụng",
  "editor.video.tooltip": "Video",
  "editor.video.dialog.tab.upload": "Tải lên",
  "editor.video.dialog.uploading": "Đang tải lên",
  "editor.video.dialog.title": "Nhúng hoặc tải lên video",
  "editor.video.dialog.link": "Liên kết",
  "editor.video.dialog.placeholder": "Liên kết",
  "editor.video.dialog.button.apply": "Áp dụng",
  "editor.table.tooltip": "Bảng",
  "editor.table.menu.insert_table": "Chèn Bảng",
  "editor.table.menu.insert_table.with_header_row": "Có hàng tiêu đề",
  "editor.table.menu.add_column_before": "Thêm Cột Trước",
  "editor.table.menu.add_column_after": "Thêm Cột Sau",
  "editor.table.menu.delete_column": "Xóa Cột",
  "editor.table.menu.add_row_before": "Thêm Hàng Trước",
  "editor.table.menu.add_row_after": "Thêm Hàng Sau",
  "editor.table.menu.delete_row": "Xóa Hàng",
  "editor.table.menu.merge_or_split_cells": "Gộp Hoặc Tách Ô",
  "editor.table.menu.delete_table": "Xóa Bảng",
  "editor.blockquote.tooltip": "Blockquote",
  "editor.horizontalrule.tooltip": "Quy tắc ngang",
  "editor.code.tooltip": "Mã",
  "editor.codeblock.tooltip": "Khối mã",
  "editor.clear.tooltip": "Xóa định dạng",
  "editor.undo.tooltip": "Hoàn tác",
  "editor.redo.tooltip": "Làm lại",
  "editor.fullscreen.tooltip.fullscreen": "Toàn màn hình",
  "editor.fullscreen.tooltip.exit": "Thoát toàn màn hình",
  "editor.imageUpload.cancel": "Hủy",
  "editor.imageUpload.crop": "Cắt",
  "editor.imageUpload.fileTypeNotSupported": "Loại tệp không được hỗ trợ",
  "editor.imageUpload.fileSizeTooBig": "Kích thước tệp quá lớn, Kích thước tối đa là",
  "editor.table.menu.insertColumnBefore": "Chèn cột trước",
  "editor.table.menu.insertColumnAfter": "Chèn cột sau",
  "editor.table.menu.deleteColumn": "Xóa cột",
  "editor.table.menu.insertRowAbove": "Chèn hàng ở trên",
  "editor.table.menu.insertRowBelow": "Chèn hàng ở dưới",
  "editor.table.menu.deleteRow": "Xóa hàng",
  "editor.table.menu.mergeCells": "Gộp các ô",
  "editor.table.menu.splitCells": "Chia ô",
  "editor.table.menu.deleteTable": "Xóa bảng",
  "editor.table.menu.setCellsBgColor": "Màu nền ô",
  "editor.emoji.tooltip": "Biểu tượng",
  "editor.iframe.tooltip": "Iframe",
  "editor.searchAndReplace.tooltip": "Tìm kiếm và thay thế",
  "editor.search.dialog.text": "Tìm kiếm",
  "editor.replace.dialog.text": "Thay thế",
  "editor.replaceAll.dialog.text": "Thay thế tất cả",
  "editor.previous.dialog.text": "Trước",
  "editor.next.dialog.text": "Tiếp theo",
  no_result_found: "Không tìm thấy kết quả",
  "Smileys & People": "Cười & Mọi người",
  "Animals & Nature": "Động vật & Thiên nhiên",
  "Food & Drink": "Thức ăn & Đồ uống",
  Activity: "Hoạt động",
  "Travel & Places": "Du lịch & Địa điểm",
  Object: "Vật",
  Symbol: "Ký hiệu",
  Flags: "Cờ",
  "Frequently used": "Thường xuyên sử dụng",
  "editor.formula.dialog.text": "Công thức",
  "editor.katex.tooltip": "Công thức toán học",
  "editor.exportPdf.tooltip": "Xuất PDF",
  "editor.exportWord.tooltip": "Xuất Word",
  "editor.importWord.tooltip": "Nhập Word",
  "editor.importWord.limitSize": "Kích thước tệp không được vượt quá",
  "editor.importWord.converting": "Đang chuyển đổi tài liệu Word, vui lòng đợi...",
  "editor.importWord.convertError": "Lỗi khi phân tích tài liệu Word",
  "editor.importWord.importError": "Lỗi khi nhập tài liệu Word",
  "editor.textDirection.tooltip": "Hướng văn bản",
  "editor.textDirection.auto.tooltip": "Tự động",
  "editor.textDirection.ltr.tooltip": "Trái sang Phải",
  "editor.textDirection.rtl.tooltip": "Phải sang Trái",
  "editor.attachment.tooltip": "Đính kèm",
  "editor.attachment.uploading": "Đang tải lên",
  "editor.attachment.please_upload": "Vui lòng tải lên tệp",
  "editor.imageGif.tooltip": "Gif",
  "editor.replace.caseSensitive": "Phân biệt chữ hoa chữ thường",
  "editor.mermaid.tooltip": "Mermaid",
  "editor.twitter.tooltip": "Twitter",
  "editor.tooltip.flipX": "Lật Ngang",
  "editor.tooltip.flipY": "Lật Dọc"
}, J = {
  "editor.remove": "移除",
  "editor.copy": "复制",
  "editor.words": "字数",
  "editor.characters": "字符数",
  "editor.default": "默认",
  "editor.recent": "最近使用",
  "editor.nofill": "无填充",
  "editor.format": "格式刷",
  "editor.delete": "删除",
  "editor.edit": "编辑",
  "editor.settings": "设置",
  "editor.table_of_content": "目录",
  "editor.draghandle.tooltip": "修改",
  "editor.copyToClipboard": "复制到剪贴板",
  "editor.slash": "按 '/' 使用命令",
  "editor.slash.empty": "无结果",
  "editor.slash.format": "格式",
  "editor.slash.insert": "插入",
  "editor.slash.embed": "嵌入服务",
  "editor.content": "请输入内容",
  "editor.fontFamily.tooltip": "字体",
  "editor.fontFamily.default.tooltip": "默认",
  "editor.moremark": "更多文本样式",
  "editor.size.small.tooltip": "小",
  "editor.size.medium.tooltip": "中",
  "editor.size.large.tooltip": "封面",
  "editor.bold.tooltip": "粗体",
  "editor.italic.tooltip": "斜体",
  "editor.underline.tooltip": "下划线",
  "editor.strike.tooltip": "删除线",
  "editor.color.tooltip": "颜色",
  "editor.color.more": "更多颜色",
  "editor.highlight.tooltip": "高亮",
  "editor.lineheight.tooltip": "行高",
  "editor.heading.tooltip": "标题",
  "editor.heading.h1.tooltip": "标题 1",
  "editor.heading.h2.tooltip": "标题 2",
  "editor.heading.h3.tooltip": "标题 3",
  "editor.heading.h4.tooltip": "标题 4",
  "editor.heading.h5.tooltip": "标题 5",
  "editor.heading.h6.tooltip": "标题 6",
  "editor.paragraph.tooltip": "段落",
  "editor.textalign.tooltip": "对齐",
  "editor.textalign.left.tooltip": "左对齐",
  "editor.textalign.center.tooltip": "居中",
  "editor.textalign.right.tooltip": "右对齐",
  "editor.textalign.justify.tooltip": "两端对齐",
  "editor.indent": "缩进",
  "editor.indent.indent": "增加缩进",
  "editor.indent.outdent": "减少缩进",
  "editor.fontSize.tooltip": "字号",
  "editor.fontSize.default.tooltip": "默认",
  "editor.superscript.tooltip": "上标",
  "editor.subscript.tooltip": "下标",
  "editor.bulletlist.tooltip": "无序列表",
  "editor.orderedlist.tooltip": "有序列表",
  "editor.tasklist.tooltip": "任务列表",
  "editor.indent.tooltip": "缩进",
  "editor.outdent.tooltip": "减少缩进",
  "editor.columns.tooltip": "列",
  "editor.link.tooltip": "链接",
  "editor.link.unlink.tooltip": "取消链接",
  "editor.link.open.tooltip": "打开链接",
  "editor.link.edit.tooltip": "编辑链接",
  "editor.link.dialog.title": "插入链接",
  "editor.link.dialog.link": "链接",
  "editor.link.dialog.text": "文本",
  "editor.link.dialog.openInNewTab": "在新标签页中打开",
  "editor.link.dialog.link.placeholder": "链接地址",
  "editor.link.dialog.text.placeholder": "添加描述",
  "editor.link.dialog.button.apply": "应用",
  "editor.image.tooltip": "图片",
  "editor.image.dragger.tooltip": "点击或拖拽图片到此区域上传",
  "editor.image.float.left.tooltip": "左浮动",
  "editor.image.float.none.tooltip": "无浮动",
  "editor.image.float.right.tooltip": "右浮动",
  "editor.image.dialog.title": "添加图片",
  "editor.image.dialog.tab.url": "链接",
  "editor.image.dialog.tab.upload": "上传",
  "editor.link.dialog.inline": "行内嵌入图片",
  "editor.image.dialog.uploading": "上传中",
  "editor.image.dialog.form.link": "链接",
  "editor.image.dialog.placeholder": "链接",
  "editor.image.dialog.form.alt": "替代文本",
  "editor.image.dialog.form.aspectRatio": "锁定原始宽高比",
  "editor.image.dialog.form.file": "文件",
  "editor.image.dialog.button.apply": "应用",
  "editor.video.tooltip": "视频",
  "editor.video.dialog.tab.upload": "上传",
  "editor.image.dialog.tab.uploadCrop": "上传并裁剪",
  "editor.video.dialog.uploading": "上传中",
  "editor.video.dialog.title": "嵌入或上传视频",
  "editor.video.dialog.link": "链接",
  "editor.video.dialog.placeholder": "链接",
  "editor.video.dialog.button.apply": "应用",
  "editor.table.tooltip": "表格",
  "editor.table.menu.insert_table": "插入表格",
  "editor.table.menu.insert_table.with_header_row": "带标题行",
  "editor.table.menu.add_column_before": "在前面插入列",
  "editor.table.menu.add_column_after": "在后面插入列",
  "editor.table.menu.delete_column": "删除列",
  "editor.table.menu.add_row_before": "在上方插入行",
  "editor.table.menu.add_row_after": "在下方插入行",
  "editor.table.menu.delete_row": "删除行",
  "editor.table.menu.merge_or_split_cells": "合并或拆分单元格",
  "editor.table.menu.delete_table": "删除表格",
  "editor.blockquote.tooltip": "引用",
  "editor.horizontalrule.tooltip": "水平线",
  "editor.code.tooltip": "代码",
  "editor.codeblock.tooltip": "代码块",
  "editor.clear.tooltip": "清除格式",
  "editor.undo.tooltip": "撤销",
  "editor.redo.tooltip": "重做",
  "editor.fullscreen.tooltip.fullscreen": "全屏",
  "editor.fullscreen.tooltip.exit": "退出全屏",
  "editor.imageUpload.cancel": "取消",
  "editor.imageUpload.crop": "裁剪",
  "editor.imageUpload.fileTypeNotSupported": "不支持的文件类型",
  "editor.imageUpload.fileSizeTooBig": "文件大小超出限制，最大大小为",
  "editor.table.menu.insertColumnBefore": "在前面插入列",
  "editor.table.menu.insertColumnAfter": "在后面插入列",
  "editor.table.menu.deleteColumn": "删除列",
  "editor.table.menu.insertRowAbove": "在上方插入行",
  "editor.table.menu.insertRowBelow": "在下方插入行",
  "editor.table.menu.deleteRow": "删除行",
  "editor.table.menu.mergeCells": "合并单元格",
  "editor.table.menu.splitCells": "拆分单元格",
  "editor.table.menu.deleteTable": "删除表格",
  "editor.table.menu.setCellsBgColor": "设置单元格背景色",
  "editor.emoji.tooltip": "表情",
  "editor.iframe.tooltip": "内嵌框架",
  "editor.searchAndReplace.tooltip": "搜索和替换",
  "editor.search.dialog.text": "搜索",
  "editor.replace.dialog.text": "替换",
  "editor.replaceAll.dialog.text": "全部替换",
  "editor.previous.dialog.text": "上一个",
  "editor.next.dialog.text": "下一个",
  no_result_found: "未找到结果",
  "Smileys & People": "笑脸和人",
  "Animals & Nature": "动物和自然",
  "Food & Drink": "食物和饮料",
  Activity: "活动",
  "Travel & Places": "旅行和地点",
  Object: "物体",
  Symbol: "符号",
  Flags: "旗帜",
  "Frequently used": "常用",
  "editor.formula.dialog.text": "公式",
  "editor.katex.tooltip": "数学公式",
  "editor.exportPdf.tooltip": "导出 PDF",
  "editor.exportWord.tooltip": "导出 Word",
  "editor.importWord.tooltip": "导入 Word",
  "editor.importWord.limitSize": "文件大小不能超过",
  "editor.importWord.converting": "正在转换 Word 文档，请稍后...",
  "editor.importWord.convertError": "解析 Word 文档出错",
  "editor.importWord.importError": "导入 Word 文档出错",
  "editor.textDirection.tooltip": "文本方向",
  "editor.textDirection.auto.tooltip": "自动",
  "editor.textDirection.ltr.tooltip": "从左到右",
  "editor.textDirection.rtl.tooltip": "从右到左",
  "editor.attachment.tooltip": "附件",
  "editor.attachment.uploading": "上传中",
  "editor.attachment.please_upload": "请上传文件",
  "editor.imageGif.tooltip": "Gif",
  "editor.replace.caseSensitive": "区分大小写",
  "editor.mermaid.tooltip": "Mermaid",
  "editor.twitter.tooltip": "Twitter",
  "editor.tooltip.flipX": "水平翻转",
  "editor.tooltip.flipY": "垂直翻转"
}, Q = {
  "editor.remove": "Eltávolítás",
  "editor.copy": "Másolás",
  "editor.words": "SZAVAK",
  "editor.characters": "KARAKTEREK",
  "editor.default": "Alapértelmezett",
  "editor.recent": "Gyakran használt",
  "editor.nofill": "Kitöltés törlése",
  "editor.format": "Formátummásoló",
  "editor.delete": "Törlés",
  "editor.edit": "Szerkesztés",
  "editor.settings": "Beállítások",
  "editor.table_of_content": "Tartalomjegyzék",
  "editor.draghandle.tooltip": "Módosítás",
  "editor.copyToClipboard": "Másolás vágólapra",
  "editor.slash": "Nyomja meg a '/' gombot a parancsokhoz",
  "editor.slash.empty": "Nincs találat",
  "editor.slash.format": "Formátum",
  "editor.slash.insert": "Beszúrás",
  "editor.slash.embed": "Szolgáltatások beágyazása",
  "editor.content": "Írjon be tartalmat",
  "editor.fontFamily.tooltip": "Betűtípus",
  "editor.fontFamily.default.tooltip": "Alapértelmezett",
  "editor.moremark": "Több betűstílus",
  "editor.size.small.tooltip": "Kicsi",
  "editor.size.medium.tooltip": "Közepes",
  "editor.size.large.tooltip": "Borítókép",
  "editor.bold.tooltip": "Félkövér",
  "editor.italic.tooltip": "Dőlt betű",
  "editor.underline.tooltip": "Aláhúzott",
  "editor.strike.tooltip": "Áthúzott",
  "editor.color.tooltip": "Szín",
  "editor.color.more": "Több szín",
  "editor.highlight.tooltip": "Kiemelés",
  "editor.lineheight.tooltip": "Sorköz",
  "editor.heading.tooltip": "Fejlécek",
  "editor.heading.h1.tooltip": "Fejléc 1",
  "editor.heading.h2.tooltip": "Fejléc 2",
  "editor.heading.h3.tooltip": "Fejléc 3",
  "editor.heading.h4.tooltip": "Fejléc 4",
  "editor.heading.h5.tooltip": "Fejléc 5",
  "editor.heading.h6.tooltip": "Fejléc 6",
  "editor.paragraph.tooltip": "Bekezdés",
  "editor.textalign.tooltip": "Igazítás",
  "editor.textalign.left.tooltip": "Bal",
  "editor.textalign.center.tooltip": "Közép",
  "editor.textalign.right.tooltip": "Jobb",
  "editor.textalign.justify.tooltip": "Sorkizárt",
  "editor.indent": "Behúzás",
  "editor.indent.indent": "Behúzás Növelése",
  "editor.indent.outdent": "Behúzás Csökkentése",
  "editor.fontSize.tooltip": "Betűméret",
  "editor.fontSize.default.tooltip": "Alapértelmezett",
  "editor.superscript.tooltip": "Felső index",
  "editor.subscript.tooltip": "Alsó index",
  "editor.bulletlist.tooltip": "Felsorolás",
  "editor.orderedlist.tooltip": "Rendezett lista",
  "editor.tasklist.tooltip": "Feladat lista",
  "editor.indent.tooltip": "Behúzás növelése",
  "editor.outdent.tooltip": "Behúzás csökkentése",
  "editor.columns.tooltip": "Oszlopok",
  "editor.link.tooltip": "Link",
  "editor.link.unlink.tooltip": "Link törlése",
  "editor.link.open.tooltip": "Link megnyitása",
  "editor.link.edit.tooltip": "Link szerkesztése",
  "editor.link.dialog.title": "Link beszúrása",
  "editor.link.dialog.link": "Link",
  "editor.link.dialog.text": "Szöveg",
  "editor.link.dialog.openInNewTab": "Megnyitás új lapon",
  "editor.link.dialog.link.placeholder": "Link célpont",
  "editor.link.dialog.text.placeholder": "Szöveg",
  "editor.link.dialog.button.apply": "Alkalmaz",
  "editor.image.tooltip": "Kép",
  "editor.image.dragger.tooltip": "Kattintson vagy húzza a feltölteni kívánt képet a területre",
  "editor.image.float.left.tooltip": "Lebegtetés balra",
  "editor.image.float.none.tooltip": "Lebegtetés törlése",
  "editor.image.float.right.tooltip": "Lebegtetés jobbra",
  "editor.image.dialog.title": "Kép hozzáadása",
  "editor.image.dialog.tab.url": "URL",
  "editor.image.dialog.tab.upload": "Feltöltés",
  "editor.image.dialog.tab.uploadCrop": "Feltöltés és körbevágás",
  "editor.image.dialog.uploading": "Feltöltés alatt",
  "editor.link.dialog.inline": "Soron belüli",
  "editor.image.dialog.form.link": "Link",
  "editor.image.dialog.placeholder": "Link",
  "editor.image.dialog.form.alt": "Alternatív szöveg",
  "editor.image.dialog.form.aspectRatio": "Eredeti képarány megtartása",
  "editor.image.dialog.form.file": "Fájl",
  "editor.image.dialog.button.apply": "Alkalmaz",
  "editor.video.tooltip": "Videó",
  "editor.video.dialog.tab.upload": "Feltöltés",
  "editor.video.dialog.uploading": "Feltöltés alatt",
  "editor.video.dialog.title": "Videó beágyazása vagy feltöltése",
  "editor.video.dialog.link": "Link",
  "editor.video.dialog.placeholder": "Link",
  "editor.video.dialog.button.apply": "Alkalmaz",
  "editor.table.tooltip": "Táblázat",
  "editor.table.menu.insert_table": "Táblázat beszúrása",
  "editor.table.menu.insert_table.with_header_row": "Fejléc sorral",
  "editor.table.menu.add_column_before": "Oszlop beszúrása balra",
  "editor.table.menu.add_column_after": "Oszlop beszúrása jobbra",
  "editor.table.menu.delete_column": "Oszlop törlése",
  "editor.table.menu.add_row_before": "Sor beszúrása felülre",
  "editor.table.menu.add_row_after": "Sor beszúrása alulra",
  "editor.table.menu.delete_row": "Sor törlése",
  "editor.table.menu.merge_or_split_cells": "Cellák egyesítése vagy szétválasztása",
  "editor.table.menu.delete_table": "Táblázat törlése",
  "editor.blockquote.tooltip": "Blokkidézet",
  "editor.horizontalrule.tooltip": "Vízszintes vonal",
  "editor.code.tooltip": "Kód",
  "editor.codeblock.tooltip": "Kód Blokk",
  "editor.clear.tooltip": "Formatálás Törlése",
  "editor.undo.tooltip": "Visszavonás",
  "editor.redo.tooltip": "Visszaállítás",
  "editor.fullscreen.tooltip.fullscreen": "Teljes képernyős mód",
  "editor.fullscreen.tooltip.exit": "Kilépés teljes képernyős módból",
  "editor.imageUpload.cancel": "Mégsem",
  "editor.imageUpload.crop": "Körbevágás",
  "editor.imageUpload.fileTypeNotSupported": "Fájltípus nem támogatott",
  "editor.imageUpload.fileSizeTooBig": "A fájlméret túl nagy, a maximum méret",
  "editor.table.menu.insertColumnBefore": "Oszlop beszúrása balra",
  "editor.table.menu.insertColumnAfter": "Oszlop beszúrása jobbra",
  "editor.table.menu.deleteColumn": "Oszlop törlése",
  "editor.table.menu.insertRowAbove": "Sor beszúrása felülre",
  "editor.table.menu.insertRowBelow": "Sor beszúrása alulra",
  "editor.table.menu.deleteRow": "Sor törlése",
  "editor.table.menu.mergeCells": "Cellák egyesítése",
  "editor.table.menu.splitCells": "Cellék szétválasztása",
  "editor.table.menu.deleteTable": "Táblázat törlése",
  "editor.table.menu.setCellsBgColor": "Cella háttérszín",
  "editor.emoji.tooltip": "Emoji",
  "editor.iframe.tooltip": "Beágyazás",
  "editor.searchAndReplace.tooltip": "Keresés és csere",
  "editor.search.dialog.text": "Keres",
  "editor.replace.dialog.text": "Csere",
  "editor.replaceAll.dialog.text": "Összes cseréje",
  "editor.previous.dialog.text": "Előző",
  "editor.next.dialog.text": "Következő",
  no_result_found: "Nincs találat",
  "Smileys & People": "Arcok és emberek",
  "Animals & Nature": "Állatok és természet",
  "Food & Drink": "Étel és ital",
  Activity: "Aktivitás",
  "Travel & Places": "Utazás és helyek",
  Object: "Tárgyak",
  Symbol: "Szimbólumok",
  Flags: "Zászlók",
  "Frequently used": "Gyakran használt",
  "editor.formula.dialog.text": "Formula",
  "editor.katex.tooltip": "Matematikai formula",
  "editor.exportPdf.tooltip": "PDF exportálása",
  "editor.exportWord.tooltip": "Word exportálása",
  "editor.importWord.tooltip": "Word importálása",
  "editor.importWord.limitSize": "A fájl mérete nem haladhatja meg",
  "editor.importWord.converting": "Word dokumentum konvertálása, kérjük, várjon...",
  "editor.importWord.convertError": "Hiba a Word-dokumentum elemzésekor",
  "editor.importWord.importError": "Hiba a Word dokumentum importálásakor",
  "editor.textDirection.tooltip": "Szövegirány",
  "editor.textDirection.auto.tooltip": "Automatikus",
  "editor.textDirection.ltr.tooltip": "Balról jobbra",
  "editor.textDirection.rtl.tooltip": "Jobbról balra",
  "editor.attachment.tooltip": "Csatolmány",
  "editor.attachment.uploading": "Feltöltés alatt",
  "editor.attachment.please_upload": "Töltse fel a fájlt",
  "editor.imageGif.tooltip": "Gif",
  "editor.replace.caseSensitive": "Kisbetű-nagybetű érzékenység",
  "editor.mermaid.tooltip": "Mermaid",
  "editor.twitter.tooltip": "Twitter",
  "editor.tooltip.flipX": "Vízszintes tükrözés",
  "editor.tooltip.flipY": "Függőleges tükrözés"
};
function Z(t) {
  return t = t || /* @__PURE__ */ new Map(), {
    /**
     * A Map of event names to registered handler functions.
     */
    all: t,
    /**
     * Register an event handler for the given type.
     * @param {string|symbol} type Type of event to listen for, or `'*'` for all events
     * @param {Function} handler Function to call in response to given event
     * @memberOf mitt
     */
    //@ts-expect-error
    on(o, n) {
      const s = t.get(o);
      s ? s.push(n) : t.set(o, [n]);
    },
    /**
     * Remove an event handler for the given type.
     * If `handler` is omitted, all handlers of the given type are removed.
     * @param {string|symbol} type Type of event to unregister `handler` from (`'*'` to remove a wildcard handler)
     * @param {Function} [handler] Handler function to remove
     * @memberOf mitt
     */
    //@ts-expect-error
    off(o, n) {
      const s = t.get(o);
      s && (n ? s.splice(s.indexOf(n) >>> 0, 1) : t.set(o, []));
    },
    /**
     * Invoke all handlers for the given type.
     * If present, `'*'` handlers are invoked after type-matched handlers.
     *
     * Note: Manually firing '*' handlers is not supported.
     *
     * @param {string|symbol} type The event type to invoke
     * @param {Any} [evt] Any value (object is recommended and powerful), passed to each handler
     * @memberOf mitt
     */
    emit(o, n) {
      let s = t.get(o);
      s && [...s].map((p) => {
        p(n);
      }), s = t.get("*"), s && [...s].map((p) => {
        p(o, n);
      });
    }
  };
}
const m = {
  lang: w,
  message: {
    en: X,
    hu_HU: Q,
    vi: Y,
    zh_CN: J,
    pt_BR: $
  }
};
class tt {
  constructor() {
    F(this, "emitter");
    this.emitter = Z();
  }
  // Getter and setter for current language
  get lang() {
    return m.lang;
  }
  set lang(o) {
    if (!this.isLangSupported(o)) {
      console.warn(
        `Can't find the current language "${o}", Using language "${m.lang}" by default`
      );
      return;
    }
    m.lang = o, this.emitter.emit("lang", o);
  }
  // Getter and setter for messages
  get message() {
    return m.message;
  }
  set message(o) {
    m.message = o;
  }
  // Load messages for a specific language
  loadLangMessage(o) {
    return this.message[o];
  }
  // Check if a language is supported
  isLangSupported(o) {
    return Object.keys(this.message).includes(o);
  }
  // Set the current language
  setLang(o) {
    this.lang = o;
  }
  // Register a language change watcher
  registerWatchLang(o) {
    return this.emitter.on("lang", o), {
      unsubscribe: () => {
        this.emitter.off("lang", o);
      }
    };
  }
  // Set messages for a specific language
  setMessage(o, n) {
    this.message[o] = n;
  }
  // Build a translation function for a given language
  buildLocalesHandler(o) {
    o || (o = this.lang);
    const n = this.loadLangMessage(o);
    return function(p) {
      return n[p] || p;
    };
  }
}
const f = new tt(), A = G(m.lang);
function kt() {
  const [t, o] = V(A), n = E(() => f.buildLocalesHandler(t), [t]);
  return L(() => {
    const s = f.registerWatchLang((p) => {
      o(p);
    });
    return () => {
      s.unsubscribe();
    };
  }, []), {
    lang: t,
    t: n
  };
}
const vt = {
  t: (t) => f.buildLocalesHandler(A())(t)
};
export {
  ft as B,
  pt as C,
  gt as D,
  it as E,
  lt as I,
  nt as T,
  I as V,
  X as a,
  Q as b,
  Y as c,
  J as d,
  $ as e,
  mt as f,
  ut as g,
  ht as h,
  ct as i,
  rt as j,
  dt as k,
  f as l,
  vt as m,
  Z as n,
  at as o,
  st as p,
  R as q,
  G as r,
  kt as u
};
